<template>
  <v-footer dark padless>
    <v-card flat tile class="secondary white--text text-center">
      <v-card-text>
        <v-btn
          v-for="(icon, i) in icons"
          :key="i"
          class="mx-4 white--text"
          :href="icon.link"
          target="_blank"
          icon
        >
          <v-icon size="24px">{{ icon.text }}</v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text class="white--text pt-0">
        Cservák György Dávid E.V.
        <br/>
        +36 70 670 2226 | 
        vendz97618@gmail.com
        <br/>
        2146 Mogyoród Pataksor út 23/2
        <br/>
        Adószám 46869946-2-33
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text">
        {{ new Date().getFullYear() }} — <strong>VZM szerviz</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<style scoped>
.v-card {
  width: 100%;
}
</style>

<script>
export default {
  data: () => ({
    icons: [
      {
        text: "mdi-phone",
        link: "tel:+36706702226",
      },
      {
        text: "mdi-gmail",
        link: "https://mail.google.com/mail/u/1/?view=cm&fs=1&to=vendz97618@gmail.com&tf=1",
      },
      {
        text: "mdi-facebook",
        link: "https://www.facebook.com/david.cservak",
      },
      {
        text: "mdi-instagram",
        link: "https://www.instagram.com/vendzszerviz/",
      },
    ],
  }),
};
</script>
